    export class NetworkDiagramState
    {
        xPos: number;
        yPos: number;
        scale: number;

        constructor() {
            this.xPos = 0;
            this.yPos = 0;
            this.scale = 1;

        }

        isValid(): boolean {
            const bad = isNaN(this.xPos) || isNaN(this.yPos) || isNaN(this.scale);
            return !bad;
        }

        setState = (xPos: number, yPos: number, scale: number) => {
            this.xPos = xPos;
            this.yPos = yPos;
            this.scale = scale;
        }


    }





// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.modelbuilder.network-diagram-state.ts